@if (selectedRows.length > 0) {
  <div class="spacing--margin-vertical spacing--margin-left">
    <button class="delete-btn" mat-stroked-button (click)="deleteOrderLines()">
      <mat-icon aria-label="Delete order lines" iconPositionEnd>delete</mat-icon>
      {{
        locale.translate('deleteOrderLines', {
          linesLength: selectedRows.length.toString(),
        }) | translate
      }}
    </button>
  </div>
}
<agr-table-v2
  #orderplanTable
  [dataSource]="dataSource"
  [withSelection]="true"
  [withStickyHeaders]="true"
  [withStickyColumns]="true"
  [customTableDataSectionHeight]="'calc(100vh - 303px)'"
  (selectionChanged)="selectionChanged($event)"
  class="orderplan-overview__table-spaced-cols"
  data-test="overview-v2-component__agr-table-v2"
>
  <ng-container matColumnDef="cropAidName" sticky>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'product' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'product' | translate" *matCellDef="let row">
      <div style="position: relative">
        @if (!row.isPackage && !row.isMainCropAid) {
          <div class="wrap-long-text display-inline">
            <div [matTooltip]="row.cropAidName" class="truncate-text">{{ row.cropAidName }}</div>
            <div class="spacing--margin-top-xs text--label text--gray">{{ row.packageAmount }} {{ row.packageUnitOfMeasurement ?? row.unitOfMeasurement }}</div>
          </div>
        }
        @if (row.isMainCropAid) {
          <div class="wrap-long-text display-inline">
            <div [matTooltip]="row.cropAidName" class="truncate-text">{{ row.cropAidName }}</div>
          </div>
        }
        @if (row.isPackage) {
          <div class="display-inline" #packageRow [id]="row.cropAidName">
            <div class="flex--row">
              <div class="hl"></div>
              {{ row.packageAmount }} {{ row.packageUnitOfMeasurement ?? row.unitOfMeasurement }}
            </div>
          </div>
        }
        <div class="add-package-container">
          @if (orderLineHasMoreThanOnePackage(row) && !allPackagesShown(row)) {
            <button
              class="add-package-btn"
              data-test="add-package-btn"
              mat-fab
              color="primary"
              [disabled]="isCropAidActive(row)"
              (click)="addOrderLine(row.cropAidId, null)"
            >
              <mat-icon>add</mat-icon>
            </button>
          }
        </div>
      </div>
    </td>
  </ng-container>
  @for (disCol of dynamicPeriodsColumns; track disCol) {
    <ng-container [matColumnDef]="disCol.columnDef">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <app-period-column-header [rowName]="disCol.headerDef"></app-period-column-header>
      </th>
      <td mat-cell [attr.aria-label]="disCol.columnDef" *matCellDef="let row">
        <app-period-column
          [row]="row"
          [columnOrderPlanPeriod]="getOrderPlanPeriodByPeriodName(row, disCol.headerDef)"
          (orderLineValueChanged)="editOrDeleteOrderLine($event, row.cropAidId)"
        ></app-period-column>
      </td>
    </ng-container>
  }
  <ng-container matColumnDef="requisiteAmount" stickyEnd>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'requisite' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'requisite' | translate" *matCellDef="let row">
      @if (!row.isPackage && (row.addedByOptimizer || row.requisiteAmount)) {
        <div class="text--bold">{{ row.requisiteAmount | agrNumber: '1.0-2' }} {{ row.unitOfMeasurement }}</div>
      }
    </td>
  </ng-container>
  <ng-container matColumnDef="customerProductInventoryAmount" stickyEnd>
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'productInventory' | translate }}
    </th>
    <td mat-cell [attr.aria-label]="'productInventory' | translate" *matCellDef="let row">
      @if (!row.isPackage) {
        <mat-form-field appearance="fill" class="orderplan__input mat-form-field__no-spacing orderplan-product-inventory" subscriptSizing="dynamic">
          <mat-label>{{ row.unitOfMeasurement }}</mat-label>
          <input
            id="input-with-cursor"
            class="orderplan__input-text"
            matInput
            [step]="0.01"
            min="0"
            maxlength="7"
            type="number"
            agrNumber
            #stockInput="ngModel"
            [ngModel]="row.customerProductInventoryAmount"
            (ngModelChange)="cropAidInventoryChanged($event, row.cropAidId, row, stockInput.control)"
          />
        </mat-form-field>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="orderLinesTotalAmount" stickyEnd>
    <th class="col-accent" mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'orderplanning' | translate }}
    </th>
    <td class="col-accent" mat-cell [attr.aria-label]="'orderplanning' | translate" *matCellDef="let row">
      @if (!row.isPackage) {
        <div>{{ row.orderLinesTotalAmount }} {{ row.unitOfMeasurement }}</div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="result" stickyEnd>
    <th class="col-accent" mat-header-cell *matHeaderCellDef mat-sort-header>
      {{ 'result' | translate }}
    </th>
    <td class="col-accent" mat-cell [attr.aria-label]="'result' | translate" *matCellDef="let row">
      @if (!row.isPackage) {
        <div [ngClass]="row.result >= 0 ? 'text-positive' : 'text-negative'">{{ row.result | number: '1.0-2' }} {{ row.unitOfMeasurement }}</div>
      }
    </td>
  </ng-container>
  <ng-container *agrTableTopBar>
    <!-- Intentionally empty to remove the top bar -->
  </ng-container>
  <ng-container *agrTableFiltersWrapper>
    <!-- Intentionally empty to remove the clear filters button -->
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay"
    class="element-row"
    [class.row-white]="!element.isAccentRowColor"
    [class.row-accent]="element.isAccentRowColor"
  ></tr>
  <tr *matNoDataRow>
    <td class="text--center" [attr.colspan]="columnsToDisplay.length">
      <agr-notification-empty
        data-test="orderplan-overview__empty"
        [isEmpty]="isEmpty$ | async"
        [emptyTitle]="'empty-title' | translate"
        [emptyDescription]="'empty-description' | translate"
        [emptyImage]="'/assets/images/no-items-3.png'"
        [emptyActionIcon]="'history'"
        [emptyActionText]="'reset-filters' | translate"
        class="spacing--margin-top"
      ></agr-notification-empty>
    </td>
  </tr>
</agr-table-v2>
@if (helpVisibleState === 'active') {
  <div class="help-legend-dismiss" role="button" tabindex="0" (click)="toggleHelp()" (keydown.enter)="toggleHelp()" (keydown.space)="toggleHelp()"></div>
}
<div>
  <div class="help-button-container" [@helpLegendToggler]="{ value: helpVisibleState }">
    <button
      class="help-button"
      (click)="toggleHelp()"
      mat-mini-fab
      [color]="helpVisibleState === 'inactive' ? 'info' : 'accent'"
      aria-label="Help button that opens legend"
    >
      <mat-icon class="help-button-icon"> help_outline</mat-icon>
    </button>
  </div>

  <div [@helpLegendContainer]="helpVisibleState" class="help-legend-container">
    <h4>{{ 'legend' | translate }}</h4>
    <div class="help-legend-item">
      <mat-form-field class="legend-input border-open">
        <input matInput id="input-with-cursor" class="orderplan__input-text" type="number" data-test="package-count-input" />
      </mat-form-field>
      &nbsp;<span>= {{ 'open' | translate }}</span>
    </div>
    <div class="help-legend-item">
      <mat-form-field class="legend-input border-incart">
        <input matInput id="input-with-cursor" class="orderplan__input-text" type="number" data-test="package-count-input" />
      </mat-form-field>
      &nbsp;<span>= {{ 'inCart' | translate }}</span>
    </div>
    <div class="help-legend-item">
      <mat-form-field class="legend-input border-ordered">
        <input matInput id="input-with-cursor" class="orderplan__input-text" type="number" data-test="package-count-input" />
      </mat-form-field>
      &nbsp;<span>= {{ 'ordered' | translate }}</span>
    </div>
    <div class="help-legend-item">
      <mat-form-field class="legend-input">
        <input matInput id="input-with-cursor" class="orderplan__input-text" type="number" data-test="package-count-input" />
        <div matSuffix>
          <mat-icon matListIcon data-test="optimizer-icon" class="input-suffix-icon">square_foot</mat-icon>
        </div>
      </mat-form-field>
      &nbsp;<span>= {{ 'orderTexts.productOptimizedTooltip' | translate }}</span>
    </div>
    <div class="help-legend-item spacing--padding-half-bottom">
      <mat-form-field class="legend-input border-yellow">
        <input matInput id="input-with-cursor" class="orderplan__input-text" type="number" data-test="package-count-input" />
      </mat-form-field>
      &nbsp;<span>= {{ 'orderTexts.productNotOptimizedTooltip' | translate }}</span>
    </div>
  </div>
</div>
